/* eslint-disable no-unused-vars */
export const enum Page {
	Home = 'Home',
	AIAnalyst = 'AIAnalyst',
	Contacts = 'Contacts',
	Segments = 'Segments',
	Campaigns = 'Campaigns',
	CXInsights = 'CXInsights',
	DataInsights = 'DataInsights',
	Help = 'Help',
	OpsInsights = 'OpsInsights',
	Settings = 'Settings',
	Dashboard = 'Dashboard',
}
